export enum ContentInsights {
  missingPillarType = 'Missing pillar type',
  missingPillarExpertise = 'Missing pillar expertise',
  missingCategory = 'Missing category',
  missingImage = 'Missing image',
  missingKeyTakeaways = 'Missing key takeaways',

  migratedPack = 'This content group was created from a previous pack.',
  migratedRagsToRichesStory = 'This lesson was created from a previous rags to riches story.',
  migratedSleepStory = 'This lesson was created from a previous sleep story.',
  migratedSpecialStory = 'This lesson was created from a previous special story.',
  migratedWisdomStory = 'This lesson was created from a previous wisdom story.',

  removeFromSale = 'This content group is set to be hidden in the app. If this is not intended, please change this selection.',
  isTestingGroup = 'This content group is visible only for testers. If this is not intended, please change this selection.',

  invalidCategory = 'There is no category with the selected name. Please select another option.',
  incompatibleCategory = 'There are no goals linking the pillar type with the selected category. Please select another option or create a goal that is linked to the two selections.',
}

export type ContentInsight =
  | typeof ContentInsights.missingPillarType
  | typeof ContentInsights.missingPillarExpertise
  | typeof ContentInsights.missingCategory
  | typeof ContentInsights.missingImage
  | typeof ContentInsights.missingKeyTakeaways
  | typeof ContentInsights.invalidCategory
  | typeof ContentInsights.incompatibleCategory
  | typeof ContentInsights.migratedPack
  | typeof ContentInsights.migratedRagsToRichesStory
  | typeof ContentInsights.migratedSleepStory
  | typeof ContentInsights.migratedSpecialStory
  | typeof ContentInsights.migratedWisdomStory
  | typeof ContentInsights.removeFromSale
  | typeof ContentInsights.isTestingGroup;

export interface CustomContentInsight {
  fieldKey?: string;
  insightText: ContentInsight;
}

export const getCustomContentInsight = (fieldKey: string | null, insightText: string) => {
  return { ...(!!fieldKey ? { fieldKey: fieldKey } : {}), insightText: insightText } as CustomContentInsight;
};
